import { useAuth } from '@/hooks/use-auth'
import { ProfilePage } from '@betstarters/ui'
import api from '@/api/client'

export function ProfilePageWrapper() {
  const { user, refreshUser } = useAuth()

  if (!user) return null

  return (
    <ProfilePage
      user={user}
      api={api}
      onProfileUpdated={refreshUser}
    />
  )
}
